import { render, staticRenderFns } from "./c-province-address.vue?vue&type=template&id=462b6564&scoped=true"
import script from "./c-province-address.vue?vue&type=script&lang=js"
export * from "./c-province-address.vue?vue&type=script&lang=js"
import style0 from "./c-province-address.vue?vue&type=style&index=0&id=462b6564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462b6564",
  null
  
)

export default component.exports